import { Component, inject, OnInit } from '@angular/core'
import { Navbar } from '../../common/navbar/navbar.component'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { MyDatePipe } from '../../../pipes/date.pipe'
import { AuthService } from '../../../services/auth.service'
import { User } from '../../../modal/person.modal'

@Component({
  selector: 'app-personal-info',
  imports: [Navbar, TranslateModule, MyDatePipe],
  templateUrl: './personal-info.component.html',
  styleUrl: './personal-info.component.css'
})
export class PersonalInfo implements OnInit {
  private authService = inject(AuthService)
  private translateService = inject(TranslateService)
  user?: User

  ngOnInit(): void {
    this.user = this.authService.getCurrentUser()
  }

  joinDate(): string | Date {
    return this.user?.created_at ?? ''
  }

  displayName(): string {
    const user = this.user
    if (!user) return '-'
    switch (this.translateService.currentLang) {
      case 'zh-CN':
        return user.name_zh_cn ?? user.name_en ?? '-'
      case 'zh-HK':
        return user.name_zh_hk ?? user.name_en ?? '-'
      default:
        return user.name_en ?? '-'
    }
  }

}
